export default {
  reset_password_title: "重置密码",
  reset_pass_desc: "请输入您的邮箱地址，我们将向您发送重置密码的链接。",
  reset_pass: "重置密码",
  reset_pass_requested: "已收到密码重置请求",
  reset_pass_check_email: "请检查您的邮箱并按照说明重置密码。",
  reset_pass_email_sent_info: "如果该邮箱存在于我们的系统中，已发送密码重置链接。",
  reset_pass_did_not_receive: "没有收到邮件？请检查您的垃圾邮件文件夹。",
  reset_pass_resend_email: "重新发送密码重置邮件",
  reset_pass_resend_available_in: "{seconds}秒后可重新发送",
  reset_pass_resending: "重新发送中...",
  reset_pass_resent_success: "密码重置邮件重新发送成功",
  reset_pass_please_wait: "请等待{seconds}秒后再重新发送",
  reset_pass_request_failed: "密码重置请求失败",
  email_required: "请输入您的邮箱地址",
  email_invalid: "请输入有效的邮箱地址",
  email_placeholder: "your{0}example.com",
  daily_limit_reached: "已达到每日重新发送限制。请明天再试。",
  remaining_attempts: "今天剩余{count}次尝试机会",
};
